import { translate } from "../../util/translate"

export const questionnaireListHeaders = [
  {
    text: translate['questionnaire.label.list.name'],
    value: 'name',
    width: 400,
  },
  {
    text: translate['questionnaire.label.list.createdAt'],
    value: 'created_at',
    width: 160,
  },
  {
    text: translate['questionnaire.label.list.type'],
    value: 'type',
    width: 160,
  },
  {
    text: translate['questionnaire.label.list.mustBeSent'],
    value: 'must_be_sent',
    width: 50,
    align: 'center',
  },
  {
    text: translate['questionnaire.label.list.published'],
    value: 'published',
    width: 50,
    align: 'center',
  },
  { value: 'actions', align: 'end', width: 150 },
]
